module.exports = {
      id: "icon-timer-usage",
      viewBox: "0 0 15.177 16",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-timer",
      toString: function () {
        return this.url;
      }
    }